export default "__VITE_ASSET__MfFUF$bJ__"